/**
 *  我的云采购
 * @document https://www.tapd.cn/38059561/markdown_wikis/show/#1138059561001000820
 */

import qs from 'qs'
import axios from '@/api/apiClient'

const api = {
  saveOrUpdateInfo: '/api/myPurchase/saveOrUpdateInfo',
  purchaseList: '/api/myPurchase/page',
  purchaseDetail: '/api/myPurchase/findDetail',
}

export default api

/**
 *
 * 新增或修改云采购信息
 * @param {Object} param
 * @param {String} param.industryId 采购（展览）二级行业id
 * @param {String} param.parentIndustryId 采购（展览）一级行业id
 * @return {*}
 */
export const setSaveOrUpdateInfo = (param) => {
  return axios.$post(`${api.saveOrUpdateInfo}`, param)
}

/**
 *  获取我的云采购列表
 */
export const getPurchaseList = (query) => {
  return axios.$get(`${api.purchaseList}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 *  获取采购（展览）详情
 */
export const getPurchaseDetail = (id, query) => {
  return axios.$get(`${api.purchaseDetail}/${id}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 热门供应商
export const getHotSupplierList = (query) => {
  return axios.$get(`/api/myPurchase/findHotSupplierPage${query ? `?${qs.stringify(query)}` : ''}`)
}

// 采购列表
// 已邀请供应商列表（洽谈和报价列表）
export const getMyCandidateSupplierList = (code, query) => {
  return axios.$get(`/api/myPurchase/${code}/suppliers/page${query ? `?${qs.stringify(query)}` : ''}`)
}

// 选中供应商（从热门供应商里选中）
export const selectSupplierInHost = (purchaseCode, companyId) => {
  return axios.$post(`/api/myPurchase/${purchaseCode}/add-to-suppliers/recommended`, { companyId })
}

// 选中供应商（从供应商列表里选中）
export const selectSupplierInList = (supplierId) => {
  return axios.$put(`/api/myPurchase/suppliers/${supplierId}/pick`)
}

// 自主下架
export const autonomousDelisting = (purchaseCode) => {
  const query = {
    purchaseCode,
  }
  return axios.put(`/api/myPurchase/updateOwnOutStatus${query ? `?${qs.stringify(query)}` : ''}`)
}

// 采购选中的热门供应商数量
export const getSelectedPopularSuppliers = (code) => {
  return axios.$get(`/api/myPurchase/pickSupplierNum/${code}`)
}

// 未选中供应商
export const getNotSelectedSupplier = (code) => {
  return axios.$get(`/api/myPurchase/${code}/suppliers/unpicked`)
}

// 批量选中供应商
export const addSelectedSuppliersBulk = (supplierIds) => {
  return axios.$put(`/api/myPurchase/suppliers/pick/batch`, {
    supplierIds,
  })
}
// 完成采购
export const completePurchase = (purchaseCode) => {
  const query = {
    purchaseCode,
  }
  return axios.$put(`/api/myPurchase/updateCompleteStatus${query ? `?${qs.stringify(query)}` : ''}`)
}

// 3.55版本的 新增/修改采购信息
export const postProductPurchase = (params) => {
  return axios.$post(`/api/myPurchase/saveOrUpdateInfo`, params)
}

// 供应商待应答采购单消息(新采购机会未读数)
export const getSupplierPendingResponsePurchaseCount = () => {
  return axios.$get(`/api/supplier/purchase/new/notice`)
}

// 应商待应答采购单列表(新采购机会)
export const getSupplierPendingResponsePurchaseList = (query) => {
  return axios.$get(`/api/supplier/purchase/new${query ? `?${qs.stringify(query)}` : ''}`)
}

// 供应商采购单列表
export const getSupplierPurchaseList = (query) => {
  return axios.$get(`/api/supplier/page${query ? `?${qs.stringify(query)}` : ''}`)
}

// 首页--采购详情页(查看他人的采购详情)
export const getOtherPurchaseDetail = (purchaseCode, query) => {
  return axios.$get(`/api/purchase/detail/${purchaseCode}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 供应商接收/拒绝采购单
export const supplierAgreePurchase = (purchaseCode, isAgree) => {
  /**
   * Query Params
status
string 
required
1 接受 -1 拒绝 -2超时未应答
   */
  return axios.$put(`/api/supplier/${purchaseCode}/agree?status=${isAgree}`)
}

// 判断我是否在供应链中
export const getIsSupplierInSupplyChain = (supplyId) => {
  return axios.$get(`/api/supplier/in/supplyChain?supplyId=${supplyId}`)
}

// 查询用户采购列表(仅APP、小程序)
export const getUserPurchaseList = (query) => {
  return axios.$get(`/api/myPurchase/app/page${query ? `?${qs.stringify(query)}` : ''}`)
}

// 供应商报价
export const supplierQuotation = (data) => {
  return axios.$post(`/api/supplier/quotation/sumbit`, data)
}

// 供应商列表（系统推荐 + 自主邀请 + 已选最终供应商）
export const getSupplierListV2 = (code, query) => {
  return axios.$get(`/api/myPurchase/${code}/suppliers/v2/page${query ? `?${qs.stringify(query)}` : ''}`)
}

// 选中供应商（从供应商列表里选中）- 带参数版本
export const selectSupplierInListV2 = (supplierId, query) => {
  return axios.$put(`/api/myPurchase/suppliers/${supplierId}/pick${query ? `?${qs.stringify(query)}` : ''}`)
}

// 采购邀请企业(自主邀请)
export const supplierInvite = (purchaseCode, memunicode) => {
  return axios.$get(`/api/myPurchase/${purchaseCode}/invite?memunicode=${memunicode}`)
}
